// JavaScript Document
$(function(){
	if (window.matchMedia('(max-width: 767px)').matches) {
	var headerHeight = $('.headerWrap').outerHeight();
		} else{
	var headerHeight = $('#menulist').outerHeight();		
		}
  $('a[href^="#"]:not(.jdgm-write-rev-link)').click(function(){
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - headerHeight - 20;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});



$(function () {
    // 別ページの場合は以下
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
			if (window.matchMedia('(max-width: 767px)').matches) {
			var headerHightUrl = $('.headerWrap').outerHeight();
				} else{
			var headerHightUrl = $('#menulist').outerHeight();		
				}
      var target = $(urlHash);
      var position = target.offset().top - headerHightUrl;
      $('body,html').stop().animate({scrollTop:position}, 400);
  }, 100);
}
});

//ページTOP
$(function() {
    var topBtn = $('#page-top img');    
//    topBtn.hide();
//    //スクロールが100に達したらボタン表示
//    $(window).scroll(function () {
//        if ($(this).scrollTop() > 500) {
//            topBtn.fadeIn();
//        } else {
//            topBtn.fadeOut();
//        }
//    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});







window.onload = function() {


// nav

if ( !window.$ && window.jQuery ){ window.$ = window.jQuery; }

$(document).ready(function(){



});
openMenu = function(){
        //$("#menulist").fadeIn();
		$('body').addClass('is-open');
 		 $('html').addClass('scroll-prevent');
        $("header .menu i").removeClass('fa-bars');
        $("header .menu i").addClass('fa-times');
		//$('.wrapContents').prepend('<div id="overlay"></div>');
        $("header .menu").unbind("click").bind("click",closeMenu);
}
$("header .menu").bind("click",openMenu);

closeMenu = function(){
        //$("#menulist").fadeOut();
		$('body').removeClass('is-open');
 		 $('html').removeClass('scroll-prevent');
        $("header .menu i").removeClass('fa-times');
        $("header .menu i").addClass('fa-bars');
		//$('#overlay').remove();
        $("header .menu").unbind("click").bind("click",openMenu);
}
$("#overlay").bind("click",closeMenu);	

if ( $("header").width() < 767 ) {
        $("#menulist a").bind("click",function(){
                closeMenu();
        });	
};




  


if (window.matchMedia('(max-width: 767px)').matches) {
	//SP処理
  var $win = $(window),
      $main = $('body'),
      $nav = $('header'),
      navHeight = $nav.outerHeight(),
      navPos = $nav.offset().top,
      fixedClass = 'is-fixed';

  $win.on('load scroll', function() {
    var value = $(this).scrollTop();
    if ( value > navPos ) {
      $nav.addClass(fixedClass);
      $main.css('padding-top', navHeight);
    } else {
      $nav.removeClass(fixedClass);
      $main.css('padding-top', '0');
    }
  }); 	
	
	
} else if (window.matchMedia('(min-width:768px)').matches) {


var navPos = jQuery( '#menulist' ).offset().top; // グローバルメニューの位置
var navHeight = jQuery( '#menulist' ).outerHeight(); // グローバルメニューの高さ
var headHeight = jQuery( 'header' ).outerHeight(); // グローバルメニューの高さ
jQuery( window ).on( 'scroll', function() {
	if ( jQuery( this ).scrollTop() > navPos ) {
		jQuery( 'body' ).css( 'padding-top', navHeight );
		//jQuery( '#menulist' ).css( 'top', headHeight );
		jQuery( '#menulist' ).css( 'top', 0 );
		jQuery( '#menulist' ).addClass( 'm_fixed' );
	} else {
		jQuery( 'body' ).css( 'padding-top', 0 );
		//jQuery( '#menulist' ).css( 'top', -headHeight );
		jQuery( '#menulist' ).css( 'top', -0 );
		jQuery( '#menulist' ).removeClass( 'm_fixed' );
	}
});

}
  
    
//アコーディオン
	
$('.shopping_guideWrap .block .box h4').on('click', function () {
  /*クリックでコンテンツを開閉*/
  $(this).next().slideToggle(500);
  /*矢印の向きを変更*/
  $(this).toggleClass('open', 500);
});  
   
  $('.faqWrap .faqBlock .faqBox dl dt').on('click', function () {
  /*クリックでコンテンツを開閉*/
  $(this).next().slideToggle(500);
  /*矢印の向きを変更*/
  $(this).toggleClass('open', 500);
});
	
$('.topInfoBox .box .ttl').on('click', function () {
  /*クリックでコンテンツを開閉*/
  $(this).next().slideToggle(500);
  /*矢印の向きを変更*/
  $(this).toggleClass('open', 500);
});
	
$('#menulist .navBox .ttl').on('click', function () {
  /*クリックでコンテンツを開閉*/
  $(this).next().slideToggle(500);
  /*矢印の向きを変更*/
  $(this).toggleClass('open', 500);
});	
  
$('#sidebarArea .list span.ac_title').on('click', function () {
  /*クリックでコンテンツを開閉*/
  $(this).next().slideToggle(500);
  /*矢印の向きを変更*/
  $(this).toggleClass('open', 500);
});	

  
}


//スライダー

$(function(){
  $('.mvSlide').slick({
	autoplay: true, //自動再生
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
		centerMode: true,
		centerPadding: '10%',		
    dots: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/mv_slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/mv_slide_next.png" class="slide-arrow next-arrow slick-next">', 
		responsive: [
			{
				breakpoint: 768,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
				dots: true,
				}
			}
		]		
  });
});

$(function(){
  $('.slide_type01').slick({
	autoplay: true, //自動再生
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 1,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',  
	responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
	  	dots: false,
      }
    }
	]	
  });
});	

	
$(function(){
  $('.workSlide').slick({
	autoplay: true, //自動再生
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 1,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',	  
	responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
	  	dots: true,
      }
    }
	]	
  });
});	

	
	  
 
if (window.matchMedia('(max-width: 767px)').matches) {
	//SP処理
} else if (window.matchMedia('(min-width:768px)').matches) {

$(window).on('load', function() {
 	const target = $('.recommendWrap .recommendSlide')
	target.slick({ 
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
		centerMode: true,
		centerPadding: '5%',
		//focusOnSelect: true,		
    slidesToShow: 3,
	slidesToScroll: 3,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/mv_slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/mv_slide_next.png" class="slide-arrow next-arrow slick-next">', 	
		responsive: [
			{
				breakpoint: 1440,
				settings: {
					centerPadding: '5%',
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}]			
		});
//target.slick("slickSetOption", "slidesToScroll", 4);	
});

  
 }
   

//jQuery(document).ready(function($){
//  function start_slick(){
//  $('.checkSlide2').slick({
//	autoplay: true, //自動再生
//	infinite: true,
//	slidesToShow: 4,
//	slidesToScroll: 1,
//    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
//    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',  
//	responsive: [
//    {
//      breakpoint: 768,
//      settings: {
//        slidesToShow: 2,
//        slidesToScroll: 1,
//        infinite: true,
//	  	dots: false,
//      }
//    }
//	]	
//  }); 
//  }
//  window.setTimeout( start_slick, 2000 );
//});

$(window).on('load', function() {
function start_slick(){
  $('.checkSlide2').slick({
	autoplay: true, //自動再生
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 1,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_prev.png" class="slide-arrow prev-arrow slick-prev">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0569/3341/7129/files/slide_next.png" class="slide-arrow next-arrow slick-next">',  
	responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
	  	dots: false,
      }
    }
	]	
  }); 
  }
  window.setTimeout( start_slick, 2500 );
});

$(window).on('load', function() {
  //セレクトボックスが切り替わったら発動
  $('[name="quantity"]').change(function() {
    //選択したvalue値を変数に格納
    var val = $(this).val();
 
    //選択したvalue値をp要素に出力
    $(this).next().attr('rel', val);
  });
 
});


//最近チェックした商品 なかったら非表示
$(window).on('load', function() {
  if(!($('#shopify-section-recently-viewed .grid__item').length)){
     $(".checkWrap").css( 'display','none' );
	} 
});

$(function() {
 
  // ①マウスをボタンに乗せた際のイベントを設定
  $('#menulist .pc > ul > li').hover(function() {
 
    // ②乗せたボタンに連動したメガメニューをスライドで表示させる
    $(this).find('.menu_contents').stop().slideDown();
 
  // ③マウスをボタンから離した際のイベントを設定
  }, function() {
 
    // ④マウスを離したらメガメニューをスライドで非表示にする
    $(this).find('.menu_contents').stop().slideUp();
 
  });
 
});

//フローティング
$(function() {
    var fixFootBtn = $('.fixFootBtn');    
    fixFootBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            fixFootBtn.fadeIn();
        } else {
            fixFootBtn.fadeOut();
        }


    });
});

$(function () {
  $('#related-products').prependTo('#relatedProductsArea');
});



$(function() {
  $(".open02").on("click", function() {
    $(this).parent('th').nextAll('td').find('.course02').toggle();
    $(this).hide();
    $(this).next().show();
  });
  $(".close02").on("click", function() {
    $(this).parent('th').nextAll('td').find('.course02').toggle();
    $(this).hide();
    $(this).prev().show();
  });
});


//フォーム関係

$(function() {
    //始めにjQueryで送信ボタンを無効化する
    $('#customer_area .submit').prop("disabled", true);
    
    //始めにjQueryで必須欄を加工する
    $('#customer_area input:required').each(function () {
        $(this).prev("label").addClass("required");
    });
    
    //入力欄の操作時
    $('#customer_area input:required, #customer_area #agree').change(function () {
        //必須項目が空かどうかフラグ
        let flag = true;
        //必須項目をひとつずつチェック
        $('#customer_area input:required, #customer_area #agree').each(function(e) {
            //もし必須項目が空なら
            if ($('#customer_area input:required').eq(e).val() === "") {
                flag = false;
            }
						if ($('#customer_area #agree').prop('checked') == false) {
								flag = false;
						}
        });
        //全て埋まっていたら
        if (flag) {
            //送信ボタンを復活
            $('#customer_area .submit').prop("disabled", false);
        }
        else {
            //送信ボタンを閉じる
            $('#customer_area .submit').prop("disabled", true);
        }
    });
});

//カートボタン　ローディング
$(function() {
	$('.cartCheckoutBtn').mouseup(function() {
		$(this).toggleClass("button-loading");
	});
});  

//再購入　金額.00とる
//$(function(){
//	setTimeout(function(){
//		var divText = $("#final_price_label").html();
//		divText = divText.replace(".00", "");
//		$("#final_price_label").html(divText);	
//	},2000);
//});

$('.customers_accountPage .hulk_reorder_button').on('shown.bs.modal', function () {
		var divText = $("#final_price_label").html();
		divText = divText.replace(".00", "");
		$("#final_price_label").html(divText);
})

$(function() {
  $('#cart-drawer .close-cart').on('click', function () {
  $('#cart-drawer').removeClass('active');

});
});  

$(function() {
  $('.floatingArea #switch').on('click', function () {
  $('.floatingArea .block').toggleClass('active');
});
});  

//カレンダー　モーダル

$(function () {
  $('.modal-open').click(function () {
    $('#overlay2, .modal-window').fadeIn();
  });
  // オーバーレイクリックでもモーダルを閉じるように
  $('.modal-close , #overlay2').click(function () {
    $('#overlay2, .modal-window').fadeOut();
  });
});


// --------------------▼　誕生日　▼--------------------

//var time = new Date();
//var year = time.getFullYear();
//
//for (var i = year; i >= 1900; i--) {
//  createOptionElements(i,'year');
//}
//
//for (var i = 1; i <= 12; i++) {
//  createOptionElements(i,'month');
//}
//
//for (var i = 1; i <= 31; i++) {
//  createOptionElements(i,'day');
//}
//
//function createOptionElements(num,parentId){
//    var doc = document.createElement('option');
//    doc.value = doc.innerHTML = num;
//    document.getElementById(parentId).appendChild(doc);
//}

// --------------------▲　誕生日　▲--------------------